<template>
  <b-container v-if="editUser === 1">
    <b-row class="my-5">
      <b-col cols="6" offset="3">
        <b-card :title="user.name + ' ' + user.lastname + ' ' + user.surname">
          <b-card-text> Correo: {{ user.email }} </b-card-text>
          <b-card-text> Teléfono: {{ user.phone }} </b-card-text>
          <b-card-text>
            Sexo:
            {{ user.gender === "1" || user.gender === 1 ? "Mujer" : null }}
            {{ user.gender === "2" || user.gender === 2 ? "Hombre" : null }}
            {{ user.gender === "3" || user.gender === 3 ? "Hombre" : null }}
          </b-card-text>
          <b-button
            @click="editUser = 2"
            class="btn text-light"
            type="submit"
            style="background: #0f182b; font-weight: bold"
          >
            Editar información
          </b-button>
          <b-button
            @click="editUser = 3"
            class="btn text-light mx-2"
            type="submit"
            style="background: #0f182b; font-weight: bold"
          >
            Cambiar contraseña
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
  <b-container v-else-if="editUser === 2">
    <b-row>
      <b-col offset="3" cols="6">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-form-group> Datos del usuario </b-form-group>
          <b-form-group id="email-group" label="E-mail" label-for="email">
            <b-form-input
              id="email"
              v-model="user.email"
              type="email"
              disabled
              aria-describedby="input-live-help-5"
            ></b-form-input>
            <b-form-text id="input-live-help-5"
              >El correo no se puede modificar</b-form-text
            >
          </b-form-group>
          <b-form-group id="name-group" label="Nombre(s)" label-for="name">
            <b-form-input
              :state="nameState"
              id="name"
              v-model="user.name"
              type="text"
              required
              aria-describedby="input-live-help input-live-feedback"
            ></b-form-input>
            <b-form-text id="input-live-help"
              >Ingresa tu nombre sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="lastname-group"
            label="Apellido Paterno"
            label-for="lastname"
          >
            <b-form-input
              id="lastname"
              :state="nameState2"
              v-model="user.lastname"
              type="text"
              required
              aria-describedby="input-live-help-2 input-live-feedback-2"
            ></b-form-input>
            <b-form-text id="input-live-help-2"
              >Ingresa tu apellido sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="surname-group"
            label="Apellido Materno"
            label-for="surname"
          >
            <b-form-input
              id="surname"
              :state="nameState3"
              v-model="user.surname"
              type="text"
              required
              aria-describedby="input-live-help-3"
            ></b-form-input>
            <b-form-text id="input-live-help-3"
              >Ingresa tu apellido sin acentos</b-form-text
            >
          </b-form-group>
          <b-form-group id="phone-group" label="Teléfono" label-for="phone">
            <b-form-input
              id="phone"
              :state="phoneValidate"
              v-model="user.phone"
              type="tel"
              required
              aria-describedby="input-live-help-4"
            ></b-form-input>
            <b-form-text id="input-live-help-4"
              >Ingresa un numero de 10 digitos</b-form-text
            >
          </b-form-group>
          <b-form-group id="gender-group" label="Género" label-for="gender">
            <b-form-select
              :state="genderValidate"
              v-model="user.gender"
              :options="options"
              aria-describedby="input-live-help-5"
            ></b-form-select>
            <b-form-text id="input-live-help-5">Elige una opción</b-form-text>
          </b-form-group>
          <b-form-group class="text-center">
            <b-button
              class="btn text-light"
              type="submit"
              style="background: #0f182b; font-weight: bold"
              :disabled="isActiveButton"
            >
              {{ !isActiveButton ? "Actualizar Datos" : "Cargando" }}
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
  <b-container v-else>
    <ChangePass :userData="userData" />
  </b-container>
</template>

<script>
const axios = require("axios");
import ChangePass from "../ChangePass.vue";

export default {
  name: "User",
  props: ["userData", "option", "dataC"],
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      editUser: 1,
      data: "",
      isActiveButton: false,
      user: {
        name: this.userData.name,
        lastname: this.userData.lastname,
        surname: this.userData.surname,
        email: this.userData.email,
        phone: this.userData.phone,
        gender: this.userData.gender,
      },
      options: [
        { value: null, text: "Selecciona una opción", disabled: true },
        { value: "1", text: "Mujer" },
        { value: "2", text: "Hombre" },
        { value: "3", text: "No binario" },
      ],
      show: true,
      letters: /^[ a-zA-Z]{1,}$/,
      phone: /^\d{10}$/,
      email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
      password: /^.{6,20}$/,
    };
  },
  components: {
    ChangePass,
  },
  computed: {
    nameState() {
      return this.letters.test(this.user.name) ? true : false;
    },
    nameState2() {
      return this.letters.test(this.user.lastname) ? true : false;
    },
    nameState3() {
      return this.letters.test(this.user.surname) ? true : false;
    },
    phoneValidate() {
      return this.phone.test(this.user.phone) ? true : false;
    },
    passwordValidate() {
      return this.password.test(this.user.password) ? true : false;
    },
    passwordValidate2() {
      return this.password.test(this.user.password_confirmation) &&
        this.user.password_confirmation === this.user.password
        ? true
        : false;
    },
    genderValidate() {
      if (this.user.gender === "" || this.user.gender === null) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    onSubmit: function (evt) {
      evt.preventDefault();
      this.isActiveButton = true;
      if ($cookies.isKey("ctoken")) {
        axios({
          method: "POST",
          url: this.api_url + "/subscriber/" + this.userData.id + "/update",
          data: {
            id: this.userData.id,
            name: this.user.name,
            lastname: this.user.lastname,
            surname: this.user.surname,
            phone: this.user.phone,
            gender: this.user.gender,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            this.$snotify.success("Usuario actualizado correctamente");
            this.$emit("option", "home");
            this.$emit("dataC", this.user);
          })
          .catch((error) => {
            console.error(error);
            this.$snotify.warning("No se ha podido actualizar el usuario");
          });
      } else {
        this.$snotify.info("No se ha podido actualizar el usuario. -- Err 002");
      }
    },
    onReset: function (evt) {
      evt.preventDefault();
      console.info("Reseteando");
    },
  },
};
</script>

<style>
</style>